import { ACCENT, illustrationA11y, lineStyle } from './static-art';

/** One drawing, framed per use: each frame keeps the crop and the line weight its original export had. */
const FRAMES = {
	card: { width: 197, height: 186.632, viewBox: '0 0 197 186.632', stroke: 1.5, dash: ['15.37 15.37', '16.52 16.52'] },
	tight: {
		width: 105,
		height: 101,
		viewBox: '13.784 17.4153 159.0668 153.0071',
		stroke: 0.96962,
		dash: ['2.8784 2.8784', '3.0904 3.0904'],
	},
	scene: {
		width: 676,
		height: 629,
		viewBox: '-45.2017 -34.9039 276.8924 257.641',
		stroke: 1.02081,
		dash: ['3.027 3.027', '3.2523 3.2523'],
	},
} as const;

export function NewPathsIllustration(props: {
	className?: string;
	label?: string;
	ink?: string;
	frame?: keyof typeof FRAMES;
}) {
	const frame = FRAMES[props.frame ?? 'card'];
	const line = lineStyle(props.ink, frame.stroke);
	return (
		<svg
			width={frame.width}
			height={frame.height}
			viewBox={frame.viewBox}
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M117.756 47.2791L136.435 43.9936C136.435 43.9936 145.23 42.0592 148.119 51.4176C151.008 60.7759 155.98 77.947 155.98 77.947"
				{...line}
			/>
			<path d="M83.7842 53.3063L112.808 48.2031" {...line} />
			<path
				d="M50.5543 159.886C50.9725 158.484 51.0354 156.997 50.7332 155.563L35.7064 93.1361C34.969 89.6246 37.2318 86.1836 40.7371 85.491C49.6163 83.734 62.9775 81.3404 69.8165 79.9965C79.6023 78.0719 82.3678 80.8519 89.8135 85.7704C95.3978 89.4593 97.5397 89.5395 98.2625 89.35C98.8258 89.2017 99.389 89.0438 99.962 88.9393L162.346 77.3939C166.509 76.6236 170.384 79.7341 170.563 83.9819L171.504 121.821V139.344C171.504 144.129 168.257 148.294 163.637 149.441L55.5173 169.917C55.5173 169.917 44.2834 172.821 40.1109 159.592C35.9384 146.363 14.9164 74.66 14.9164 74.66C14.9164 74.66 12.349 66.2713 19.7319 64.6577C21.1268 64.354 26.288 63.4038 33.741 62.0648L78.628 54.1719"
				{...line}
			/>
			<path d="M108.99 86.9509C108.565 86.7176 108.159 86.4503 107.774 86.1562" {...line} />
			<path
				d="M105.774 84.1044C104.009 81.7181 103.213 78.5857 103.828 75.6671C104.828 70.9041 108.904 67.5142 111.455 63.3733C113.304 60.3745 114.353 56.9529 115.238 53.5387C115.762 51.5192 115.467 46.4525 114.619 43.0625"
				strokeDasharray={frame.dash[0]}
				{...line}
			/>
			<path d="M114.211 41.6824C114.017 41.1478 113.807 40.7006 113.577 40.375" {...line} />
			<path
				d="M118.891 31.5124C119.8 27.3572 118.213 23.4752 115.347 22.8417C112.481 22.2083 109.421 25.0632 108.512 29.2185C107.603 33.3737 109.19 37.2557 112.056 37.8892C114.922 38.5226 117.982 35.6677 118.891 31.5124Z"
				fill={ACCENT}
			/>
			<path
				d="M119.494 26.4398C122.223 24.6755 125.431 22.8335 128.533 23.7958C129.463 24.085 130.305 24.6123 131.059 25.232C132.125 26.1044 133.094 27.3341 132.986 28.7119C132.896 29.8492 132.098 30.7872 131.339 31.6378C129.761 33.4044 128.071 35.2416 125.82 35.9585C123.306 36.758 120.35 35.8807 118.672 33.8346"
				{...line}
			/>
			<path
				d="M109.67 25.3529C107.756 22.7186 105.423 19.8414 102.186 19.6154C101.214 19.5473 100.24 19.7369 99.314 20.0407C98.0086 20.4708 96.6621 21.2654 96.2705 22.5898C95.9465 23.6834 96.3551 24.8474 96.7588 25.9142C97.6001 28.1329 98.5163 30.4609 100.358 31.9433C102.418 33.6006 105.491 33.8509 107.787 32.5484"
				{...line}
			/>
			<path
				d="M77.0694 40.1866C78.9557 37.9268 77.8566 33.878 74.6145 31.1432C71.3723 28.4085 67.2149 28.0235 65.3286 30.2833C63.4422 32.5431 64.5414 36.5919 67.7835 39.3267C71.0257 42.0614 75.1831 42.4464 77.0694 40.1866Z"
				fill={ACCENT}
			/>
			<path
				d="M64.2272 35.25C60.9926 35.527 57.3351 36.0349 55.4615 38.6983C54.9007 39.4978 54.555 40.4334 54.3326 41.386C54.0183 42.7323 53.9966 44.2997 54.9176 45.3252C55.6791 46.1733 56.8806 46.426 57.9974 46.6326C60.3206 47.0627 62.7743 47.4855 64.9935 46.6715C67.4714 45.7626 69.2796 43.2547 69.3667 40.6059"
				{...line}
			/>
			<path
				d="M71.354 28.7664C71.2718 25.5052 71.3733 21.7944 73.8004 19.6292C74.5281 18.9804 75.4153 18.5308 76.3339 18.2052C77.6297 17.7435 79.1768 17.5491 80.2913 18.3559C81.2123 19.0241 81.5943 20.1979 81.923 21.2914C82.6048 23.5636 83.2913 25.9694 82.7305 28.2755C82.1043 30.8514 79.8223 32.934 77.2139 33.3131"
				{...line}
			/>
			<path d="M75.2188 79.4737C75.2091 78.9488 75.2043 78.4652 75.2067 78.0156" {...line} />
			<path
				d="M75.4053 74.9182C75.6035 73.5524 75.9685 72.228 76.6043 70.3593C77.6632 67.239 79.4351 64.3934 80.4142 61.2464C81.8816 56.5247 81.3836 51.2417 79.162 46.8359"
				strokeDasharray={frame.dash[1]}
				{...line}
			/>
			<path d="M78.4075 45.4914C78.1537 45.0783 77.8829 44.6749 77.5977 44.2812" {...line} />
		</svg>
	);
}
